<template>
  <van-popup :value="value" @input="$emit('input', $event)" position="bottom" closeable :style="{ overflow: 'hidden' }">
    <div class="selectInfo">
      <div class="title">{{ title }}</div>
      <div v-for="(item, index) in selectList" :key="index" class="selectItem" @click="handleSelect(item)">
        <span>{{ item.text }}</span>
        <input type="radio" class="circle-checkbox" :value="item.val" v-model="selectedValue" />
      </div>
    </div>
  </van-popup>
</template>

<script>
export default {
  props: {
    value: Boolean,
    title: String,
    selectList: {
      type: Array,
      default: () => [],
    },
    selectedValue: [String, Number],
    onSelect: {
      type: Function,
      required: true,
    },
  },
  methods: {
    handleSelect(item) {
      this.onSelect(item);
      this.$emit("input", false);
    },
  },
};
</script>
<style lang="less" scoped>
.selectInfo {
  padding: 0 15px 15px 15px;

  .title {
    margin: 15px;
    text-align: center;
    font-size: 16px;
    font-weight: bold;
    color: var(--text_color);
  }

  .selectItem {
    padding: 15px 0;
    display: flex;
    align-items: center;
    justify-content: space-between;

    span {
      font-size: 14px;
      font-weight: normal;
      color: var(--text_color);
      overflow-wrap: break-word;
      word-break: break-word;
      max-width: 80%;
    }
  }
}

.van-popup--bottom {
  border-radius: 15px 15px 0 0;
  background: var(--background_color);
}

::v-deep .van-popup__close-icon {
  font-size: 18px;
  color: var(--ntext_color);
}

.circle-checkbox {
  appearance: none;
  /* 移除默认样式 */
  -webkit-appearance: none;
  /* Safari 兼容性 */
  width: 15px;
  /* 圆的直径 */
  height: 15px;
  /* 圆的直径 */
  border: 1px solid var(--ntext_color);
  /* 边框颜色 */
  border-radius: 50%;
  /* 圆形样式 */
  background-color: var(--background_color);
  /* 默认背景色 */
  cursor: pointer;
  position: relative;
  transition: background-color 0.3s ease;
}

.circle-checkbox:checked {
  background-color: var(--primary_color);
  /* 选中时背景色 */
  border-color: var(--primary_color);
  /* 选中时边框色 */
}

.circle-checkbox:checked::after {
  content: '✓';
  /* 显示对号 */
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: #fff;
  /* 对号颜色 */
  font-size: 8px;
  /* 对号大小 */
}
</style>
